export const loggedInRole = JSON.parse(
  sessionStorage.getItem("usrlgndtls")
)?.roleId;
